import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _pt from 'prop-types';
import 'react';
import { css } from '@emotion/react';
import { customProperties } from '@commercetools-uikit/design-system';
import { filterDataAttributes } from '@commercetools-uikit/utils';
import Inset from '@commercetools-uikit/spacings-inset';
import { jsx } from '@emotion/react/jsx-runtime';

function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
        return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context;

      _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context2;

      _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var Card = function Card(props) {
  return jsx("div", _objectSpread(_objectSpread({}, filterDataAttributes(props)), {}, {
    css: /*#__PURE__*/css("box-sizing:border-box;width:100%;font-size:1rem;box-shadow:", props.type === 'raised' ? customProperties.shadow1 : 'none', ";border-radius:", customProperties.borderRadius6, ";background:", props.theme === 'dark' ? customProperties.colorNeutral95 : customProperties.colorSurface, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Card;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */") // Allow to override the styles by passing a `className` prop.
    // Custom styles can also be passed using the `css` prop from emotion.
    // https://emotion.sh/docs/css-prop#style-precedence
    ,
    className: props.className,
    children: props.insetScale === 'none' ? // Use a `<div>` to ensure that there is always a wrapper container.
    // This is mostly useful in case custom styles are targeting this element.
    jsx("div", {
      children: props.children
    }) : jsx(Inset, {
      scale: props.insetScale,
      children: props.children
    })
  }));
};

Card.propTypes = process.env.NODE_ENV !== "production" ? {
  type: _pt.oneOf(['raised', 'flat']).isRequired,
  insetScale: _pt.oneOf(['none', 's', 'm']).isRequired,
  theme: _pt.oneOf(['light', 'dark']).isRequired,
  className: _pt.string,
  children: _pt.node
} : {};
var defaultProps = {
  type: 'raised',
  theme: 'light',
  insetScale: 'm'
};
Card.displayName = 'Card';
Card.defaultProps = defaultProps;
var Card$1 = Card; // NOTE: This string will be replaced on build time with the package version.

var version = "12.2.9";
export { Card$1 as default, version };